export const userProfileDropdowns = {
  gsc: "GSC",
  roles: "ROLES",
  skills: "skills",
  lob: "LOB",
  tenderApplicable: "Tender Applicable",
  countryCode: "Country Code",
  carrierCode: "Carrier Code",
};
